import {
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    useTheme
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteRoundedIcon from "@mui/icons-material/Delete";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {checkValueWithInterval} from "../../../component/Utils";

interface EarlyBookingsProps {
    earlyBookings: any[],
    setEarlyBookings: Function,
    errorMessage: any,
    setErrorMessage: Function
}


const EarlyBookings = ({earlyBookings, setEarlyBookings, errorMessage, setErrorMessage}: EarlyBookingsProps) => {
    const theme = useTheme();
    const accentColor = theme.palette.accent.main;
    const {t} = useTranslation(['salesmarketing', 'translation']);
    const MIN = 0;
    const MAX = 100;

    function handleEarlyBookingChange(id: number, field: string, value: any) {
        if (value != "") {
            // reset errors
            let copyErrMsg = {...errorMessage};
            delete copyErrMsg[field+id];
            setErrorMessage(copyErrMsg);
        } else {
            let copyErrMsg = {...errorMessage};
            copyErrMsg[field+id] = t('salesmarketing:promo.createForm.requiredCheck');
            setErrorMessage(copyErrMsg);
        }
        let result = earlyBookings.map((s: any) => s.id === id ? {...s, [field]: value} : s);
        setEarlyBookings(result);
    }

    function deleteEarlyBooking(id: number) {
        let filteredList = earlyBookings.filter((s: any) => s.id !== id);
        setEarlyBookings(filteredList);
    }

    return (
        <TableContainer sx={{paddingTop: "10px"}}>
            <Table aria-label="ancillaries-table">
                <TableHead>
                    <TableRow>
                        <TableCell>{t('salesmarketing:promo.earlyBookings.early')}</TableCell>
                        <TableCell>{t('salesmarketing:promo.earlyBookings.discount')}</TableCell>
                        <TableCell>{t('salesmarketing:promo.earlyBookings.delete')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {earlyBookings.map((row: any, index: number) => (
                        <TableRow
                            key={"sub" + index}
                        >
                            <TableCell>
                                <TextField
                                    required
                                    //label={t('salesmarketing:promo.earlyBookings.early')}
                                    fullWidth
                                    name="earlyBookingEarly"
                                    type="number"
                                    value={row.early}
                                    onChange={(e) => handleEarlyBookingChange(row.id, "early", e.target.value)}
                                    error={errorMessage && !!errorMessage["early"+row.id]}
                                    helperText={errorMessage && errorMessage["early"+row.id]}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    required
                                    //label={t('salesmarketing:promo.earlyBookings.discount')}
                                    fullWidth
                                    type="number"
                                    name="earlyBookingDiscount"
                                    value={row.discount}
                                    onChange={(e) => {
                                        handleEarlyBookingChange(row.id, "discount", checkValueWithInterval(e.target.value, MIN, MAX))
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">%</InputAdornment>
                                    }}
                                    error={errorMessage && !!errorMessage["discount"+row.id]}
                                    helperText={errorMessage && errorMessage["discount"+row.id]}
                                />

                            </TableCell>
                            <TableCell>
                                <IconButton
                                    aria-label="close"
                                    onClick={() => deleteEarlyBooking(row.id)}
                                >
                                    <DeleteRoundedIcon sx={{color: accentColor}}/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default EarlyBookings